import { useState, useEffect } from "react";
import { apiService } from "../api/api";

export const useVideoReportStatus = () => {
  const [videoReportCheck, setVideoReportCheck] = useState<boolean | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const checkVideoReportStatus = async () => {
    try {
      setLoading(true);
      setError(null);

      const result = await apiService.youtubeScorecard.videoReportCheck();
      setVideoReportCheck(result);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Failed to check video report status"
      );
      console.error("Error checking video report status:", err);
      setVideoReportCheck(false); // Set to false in case of error
    } finally {
      setLoading(false);
    }
  };

  const refreshStatus = () => {
    checkVideoReportStatus();
  };

  useEffect(() => {
    checkVideoReportStatus();
  }, []);

  return { videoReportCheck, loading, error, refreshStatus };
};
